import { Aggregate } from './aggregate';
import { FilterHandler } from '../shared/filter-handler';

import { Ship } from './ship';
import { Specie } from './specie';

export class CaptureAggregate extends Aggregate {
  average = 0;
  percent = 0;

  constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }

  apiMap(values: Object = {}) {
    const capture = new CaptureAggregate(values);

    // Map totals by year
    capture.totals = [];
    for (const value in values) {
      if (values.hasOwnProperty(value)) {
        const parts = value.split('_');
        if (parts[0] === 'total') {
          capture.addTotal(parts[1], values[value]);
        }
      }
    }

    return capture;
  }
}

export class CaptureAggregateFilter extends FilterHandler {
  specie: Specie[] = [];
  ship: Ship[] = [];
  ship_type: string;
  start_date: string;
  end_date: string;
  data_type: string;

  constructor(values: Object = {}) {
    super();

    this.specie = [];
    this.ship = [];
    this.ship_type = '';
    this.start_date = '';
    this.end_date = '';
    this.data_type = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/capture-aggregate.ts